import Lookup from 'src/componentes/select2';

const TipoPontoControleLookup = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/TipoPontoControleLookup"
      clearable={clearable}
      {...props}
    />
  );
};

export default TipoPontoControleLookup;
